<template>
  <!-- 提成分摊 -->
  <div>
    <div class="glo_Table">
      <!-- 按钮列表 -->
      <div class="glo_btnList" ref="btnList">
        <div class="glo_btnList_left">
          <el-button v-if="hasPermiss('admin:dispatch:saveCommission')" class="glo_btnItems glo_bgcMainColor" @click="saveBtn">保存</el-button>
          <el-button v-if="hasPermiss('admin:dispatch:postingCommission')" class="glo_btnItems" @click="postingCommission">过账</el-button>
          <el-button v-if="hasPermiss('admin:dispatch:backPostingCommission')" class="glo_btnItems" @click="backPostingCommission">反过账</el-button>
        </div>
      </div>
      <!-- 预览详情 -->
      <div class="detailsBox" ref="queryForm">
        <div class="item">
          <div class="dItemLabel">发车批次号:</div>
          <div class="dItemVal">{{ driverVo.number }}</div>
        </div>
        <div class="item">
          <div class="dItemLabel">车型:</div>
          <div class="dItemVal">{{ driverVo.carType }}</div>
          <!-- <div class="ditemBtn color00f">更换</div> -->
        </div>
        <div class="item">
          <div class="dItemLabel">最大载重:</div>
          <div class="dItemVal">{{ driverVo.loadableCapacity }}</div>
        </div>
        <div class="item">
          <div class="dItemLabel">最大体积:</div>
          <div class="dItemVal">{{ driverVo.loadableVolume }}</div>
        </div>
        <div class="item">
          <div class="dItemLabel">车牌号:</div>
          <div class="dItemVal">{{ driverVo.carNumber }}</div>
        </div>
        <div class="item">
          <div class="dItemLabel">司机:</div>
          <div class="dItemVal">{{ driverVo.driverName }}</div>
        </div>
        <div class="item">
          <div class="dItemLabel">押运员:</div>
          <div class="dItemVal">{{ driverVo.supercargoName }}</div>
        </div>
        <div class="item">
          <div class="dItemLabel">途径站点:</div>
          <div class="dItemVal" style="color: #f00">{{ driverVo.stationCount }}个</div>
        </div>
        <div class="item color00f">
          <div class="dItemLabel">司机人数:</div>
          <div class="dItemVal">{{ driverVo.driverCount }}</div>
        </div>
        <div class="item color00f">
          <div class="dItemLabel">押运人数:</div>
          <div class="dItemVal">{{ driverVo.supercargoCount }}</div>
        </div>
      </div>
      <!-- 查询条件 -->
      <div ref="queryForm2">
        <el-form :model="queryData" class="glo_form" label-position="left">
          <el-form-item class="queryItems" label="装卸费单价:">
            <el-input placeholder="请输入" clearable v-model="queryData.danjia" @keyup.enter.native="autoDanjia"></el-input>
          </el-form-item>
          <el-button class="glo_bgcMainColor inputBtns" @click="autoDanjia">计算</el-button>
        </el-form>
      </div>
      <div class="glo_Table flexTable">
        <div class="leftTable">
          <el-table :height="tableHeigth4" header-align="center" ref="mytable1" :data="tableData4" border stripe show-summary :summary-method="getSummaries">
            <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
            <!-- <el-table-column
              fixed="left"
              align="center"
              type="selection"
              width="60"
            ></el-table-column>-->
            <template v-for="(item, index) in myTableHeard4">
              <!-- 某个字段需要单独操作  例如点击可以跳转 -->
              <el-table-column
                v-if="item.field == 'aaaa' && item.isShow"
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                width="item.width"
                :data-isTotal="item.isTotal"
              >
                <template slot-scope="scope">
                  <div class="linkTabel" @click.stop="goYdDetails(scope.row)">{{ scope.row.memberNickname }}</div>
                </template>
              </el-table-column>
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-else-if="item && item.isShow"
              ></el-table-column>
            </template>
            <el-table-column label="装卸单价" prop="loadFee" align="center" :show-overflow-tooltip="true" width="100" fixed="right">
              <template slot-scope="scope">
                <el-input class="inputFare" placeholder="请输入" @input="inputNum1($event, scope.$index)" v-model="tableData4[scope.$index].loadUnitPrice"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="装卸费" prop="loadFee" align="center" :show-overflow-tooltip="true" width="100" fixed="right">
              <template slot-scope="scope">
                <el-input class="inputFare" placeholder="请输入" @input="inputNum1($event, scope.$index)" v-model="tableData4[scope.$index].loadFee"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="其他费用" prop="otherFee" align="center" :show-overflow-tooltip="true" width="100" fixed="right">
              <template slot-scope="scope">
                <el-input class="inputFare" placeholder="请输入" @input="inputNum1($event, scope.$index)" v-model="tableData4[scope.$index].otherFee"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="押运提成" prop="escortCommissionFee" align="center" :show-overflow-tooltip="true" width="100" :data-isTotal="true" fixed="right">
              <template slot-scope="scope">
                <el-input class="inputFare" placeholder="请输入" @input="inputNum1($event, scope.$index)" v-model="tableData4[scope.$index].escortCommissionFee"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="司机提成" prop="driverCommissionFee" align="center" :show-overflow-tooltip="true" width="100" :data-isTotal="true" fixed="right">
              <template slot-scope="scope">
                <el-input class="inputFare" placeholder="请输入" @input="inputNum1($event, scope.$index)" v-model="tableData4[scope.$index].driverCommissionFee"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="总费用" prop="totalFee" align="center" :show-overflow-tooltip="true" width="100" :data-isTotal="true" fixed="right">
              <template slot-scope="scope">
                <el-input class="inputFare" placeholder="自动合计" disabled style="color: #f00" v-model="tableData4[scope.$index].totalFee"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import jsPDF from "jspdf";
import _ from "lodash";
export default {
  data() {
    return {
      queryData: {
        danjia: "",
      },
      tableHeigth4: "75vh", //第四步表格高度
      myTableHeard4: [
        {
          name: "任务编号",
          field: "number",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "运单号",
          field: "waybillNumber",
          width: "160",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "运输类型",
          field: "transportMethodShow",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "运输计划",
          field: "transportPlanShow",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "提货单号",
          field: "takeAddrNumber",
          width: "200",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "装货地址",
          field: "loadAddrAddress",
          width: "180",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "卸货地址",
          field: "unloadAddress",
          width: "180",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "状态",
          field: "taskStatusShow",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "计费取值",
          field: "billingWeight",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },

        {
          name: "毛重",
          field: "grossWeight",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "净重",
          field: "netWeight",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "体积(m³)",
          field: "volume",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "规格",
          field: "specs",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
      ],
      tableData4: [], //

      selectTableData4: [],
      driverVo: {
        carNumber: "",
        carType: "",
        dispatchContractNumber: "",
        driverCount: "",
        driverName: "",
        loadableCapacity: "",
        loadableVolume: "",
        number: "",
        stationCount: "",
        supercargoCount: "",
        supercargoName: "",
        trailerNumber: "",
      },

      dispatchId: "",
      totalArr: [
        "loadFee",
        "otherFee",
        "escortCommissionFee",
        "driverCommissionFee",
        "totalFee",
        "netWeight",
        "grossWeight",
        "volume",
        "billingWeight",
      ],
    };
  },
  watch: {},
  created() {},
  mounted() {
    let totalArr = [];
    //提取需要合计的字段
    // for (var i = 0; i < this.myTableHeard4.length; i++) {
    //   if (this.myTableHeard4[i].isTotal) {
    //     totalArr.push(this.myTableHeard4[i].field);
    //   }
    // }
    // this.totalArr = totalArr;
  },
  activated() {
    let dispatchId = this.$route.query.dispatchId || "";
    if (dispatchId) {
      this.dispatchId = dispatchId;
      this.getData();
    }
  },
  destroyed() {},
  methods: {
    autoDanjia() {
      if (!this.queryData.danjia) {
        this.$message.warning("请先输入装卸费单价");
        return false;
      }
      this.curBillingSums("netWeight");
      this.tableData4.forEach((item2, idx2) => {
        this.inputNum1("", idx2);
      });
    },
    curBillingSums(key) {
      // 计算 运费均摊
      let { danjia } = this.queryData;
      let arrs = _.cloneDeep(this.tableData4);
      arrs.forEach((element, index) => {
        element.loadUnitPrice = danjia;
        element.loadFee =
          element[key] == 0 ? "" : this.$TOOLS.mul(element[key], danjia);
      });
      this.tableData4 = arrs;
      this.$message.success("计算成功");
    },
    saveBtn() {
      // 保存提成分摊
      let taskList = JSON.parse(JSON.stringify(this.tableData4)) || [];
      let arrs = [];
      console.log("taskList", taskList);
      for (var i = 0; i < taskList.length; i++) {
        let obj = {
          loadUnitPrice: taskList[i].loadUnitPrice || 0,
          driverCommissionFee: taskList[i].driverCommissionFee || 0,
          escortCommissionFee: taskList[i].escortCommissionFee || 0,
          loadFee: taskList[i].loadFee || 0,
          otherFee: taskList[i].otherFee || 0,
          taskId: taskList[i].taskId,
        };
        arrs.push(obj);
      }
      this.$API
        .saveCommission({
          billTmsDispatchId: this.dispatchId,
          taskList: arrs,
        })
        .then((res) => {
          this.$message.success(res.data.message || "操作成功");
        });
    },
    // 过账提成分摊
    postingCommission() {
      this.$confirm("是否对该提成分摊进行 过账 操作?", "提示:")
        .then(() => {
          let taskList = JSON.parse(JSON.stringify(this.tableData4)) || [];
          let arrs = [];
          for (var i = 0; i < taskList.length; i++) {
            let obj = {
              driverCommissionFee: taskList[i].driverCommissionFee || 0,
              escortCommissionFee: taskList[i].escortCommissionFee || 0,
              loadFee: taskList[i].loadFee || 0,
              otherFee: taskList[i].otherFee || 0,
              taskId: taskList[i].taskId,
            };
            arrs.push(obj);
          }
          this.$API
            .postingCommission({
              billTmsDispatchId: this.dispatchId,
              taskList: arrs,
            })
            .then((res) => {
              this.$message.success(res.data.message || "操作成功");
            });
        })
        .catch(() => {});
    },
    // 反过账提成分摊
    backPostingCommission() {
      this.$confirm("是否对该提成分摊进行 反过账 操作?", "提示:")
        .then(() => {
          this.$API
            .backPostingCommission({
              dispatchId: this.dispatchId,
            })
            .then((res) => {
              this.$message.success(res.data.message || "操作成功");
            });
        })
        .catch(() => {});
    },

    getData() {
      this.$API
        .getDispatchCommissionList({
          dispatchId: this.dispatchId,
        })
        .then((res) => {
          let datas = res.data.result || "";

          if (datas && datas.taskList.length > 0) {
            let lists = datas.taskList || [];

            lists.forEach((item) => {
              item.loadFeeDJ =
                this.$TOOLS
                  .divide(item.loadFee || 0, item.netWeight || 0)
                  .toFixed(2) || 0;
            });

            this.tableData4 = lists;
          }
          if (datas && datas.driverVo) {
            this.driverVo = datas.driverVo || [];
          }

          this.$nextTick(() => {
            this.fetTableHeight();
          });
        });
    },

    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(
                    this.$TOOLS.add(prev, curr),
                    3
                  );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable1.doLayout();
      });
      return sums;
    },
    inputNum1(e, idx) {
      let v1 = this.tableData4[idx].loadFee || 0; //装卸费
      let v2 = this.tableData4[idx].otherFee || 0; //其他费用
      let v3 = this.tableData4[idx].escortCommissionFee || 0; //押运提成
      let v4 = this.tableData4[idx].driverCommissionFee || 0; //司机提成
      let loadUnitPrice = this.tableData4[idx].loadUnitPrice || 0; //司机提成
      let dNum = this.$TOOLS.add(v1, v2).toFixed(2);
      let yNum = this.$TOOLS.add(v3, v4).toFixed(2);
      let suu = this.$TOOLS.add(yNum, dNum).toFixed(2);
      this.tableData4[idx].totalFee = this.$TOOLS
        .add(suu, loadUnitPrice)
        .toFixed(2);
    },

    /***
     * ==============设置表格动态高度==============
     */
    fetTableHeight() {
      // 重置table高度
      this.tableHeigth4 = 0;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      let queryHeigth = this.$refs.queryForm.offsetHeight + 20 || 50; //10==margin-top: 10  查询框高度
      let btnListHeight = this.$refs.btnList.offsetHeight; // 按钮列表高度
      // if (this.isHaseMore) {
      //   queryHeigth = this.$refs.queryForm.offsetHeight + 10; //查询框
      // }
      let pagsHeigth = 40 + 20; //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + btnListHeight + 40 + 60 + 24; //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //

      this.$nextTick(() => {
        this.tableHeigth4 = tabHeight;
        this.$refs.mytable1.doLayout();
        // this.$refs.mytable2.doLayout();
      });
    },
  },
};
</script>
<style scoped lang="less">
.detailsBox {
  display: flex;
  flex-wrap: wrap;
  background-color: #f2f2f2;
  padding: 10px 10px 0;
  font-size: 16px;
  margin-bottom: 20px;

  .item {
    display: flex;
    margin-right: 40px;
    min-width: 200px;
    margin-bottom: 10px;

    .dItemLabel {
      margin-right: 10px;
    }
    .ditemBtn {
      // color: #0000ff;
      margin-left: 20px;
    }
  }
}
.color00f {
  color: #0000ff;
}

.flexTable {
  display: flex;
  width: 100%;

  .leftTable {
    flex: 1;
    overflow-x: auto;
  }

  .rigtTable {
    width: 562px;
    margin-left: 20px;

    /deep/ .el-input.is-disabled .el-input__inner {
      color: #0000ff !important;
    }
  }
}

.inputBtns {
  height: 32px;
  line-height: 32px;
  padding: 0 10px;
}
</style>
